import React from 'react';
import { cn } from '@/lib/cn';

export interface LinkCellProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Icon component to display on the left */
  icon: React.ComponentType<{ className?: string }>;
  /** Label text to display */
  label: string;
}

export function LinkCell({ icon: Icon, label, className, ...props }: LinkCellProps) {
  return (
    <div
      className={cn(
        // Base layout and styling
        'flex items-center gap-2 px-2 py-3 rounded-xl cursor-pointer',
        'bg-primary transition-colors',
        // Hover state
        'hover:bg-primary-hover',
        // Press state (active)
        'active:bg-primary-hover',
        className,
      )}
      {...props}
    >
      {/* Icon */}
      <div className="shrink-0">
        <Icon className="w-4 h-4 icon-accent" />
      </div>

      {/* Label */}
      <span className="text-body-2-high text-accent whitespace-nowrap">{label}</span>
    </div>
  );
}

export default LinkCell;
